
import React from 'react';
import { Message } from "@/types/message";
import MessageCard from "../../MessageCard";

interface LatestThreadGroupProps {
  thread: {
    threadId: string;
    messages: Message[];
    latestMessage: Message;
    timestamp: Date;
    hasMultipleVersions: boolean;
  };
  companyName: string;
  onRegenerateAIResponse?: (messageId: string, tone: string, customInstructions?: string) => Promise<Message | null>;
  isRegenerating?: boolean;
  regeneratingMessageId?: string;
  orderNumber?: string;
  userEmail?: string;
  sellerEmail?: string;
  latestAIMessage?: Message;
  getTypeIndicator: (type: string) => { icon: JSX.Element, color: string };
}

const LatestThreadGroup = ({
  thread,
  companyName,
  onRegenerateAIResponse,
  isRegenerating,
  regeneratingMessageId,
  orderNumber = "",
  userEmail = "",
  sellerEmail = "",
  latestAIMessage,
  getTypeIndicator
}: LatestThreadGroupProps) => {
  return (
    <div className="mb-2 last:mb-0 relative">
      {/* Timeline connector for latest thread */}
      <div className="absolute left-4 top-0 h-full w-[1px] bg-primary-foreground/20 hidden md:block" />
      
      {/* Latest thread always shown fully */}
      {thread.messages.map((message, messageIndex) => {
        const isLatestInThread = messageIndex === thread.messages.length - 1;
        const isRegenerated = Boolean(message.relatedToMessageId);
        const { color } = getTypeIndicator(message.type);
        
        return (
          <div key={message.id} className="relative">
            {/* Timeline dot for each message in latest thread */}
            <div className={`absolute left-4 top-5 w-2 h-2 rounded-full ${color} z-10 hidden md:block`} />
            
            <MessageCard
              message={{
                ...message,
                isRegenerated
              }}
              companyName={companyName}
              onRegenerateAIResponse={isLatestInThread && message.type === "ai" ? onRegenerateAIResponse : undefined}
              isLatestAIMessage={latestAIMessage && message.id === latestAIMessage.id}
              isRegenerating={isRegenerating && regeneratingMessageId === message.id}
              orderNumber={orderNumber}
              userEmail={userEmail}
              sellerEmail={sellerEmail}
              id={isLatestInThread ? "latest-message" : `message-${message.id}`}
              isLatestMessage={isLatestInThread}
            />
          </div>
        );
      })}
    </div>
  );
};

export default LatestThreadGroup;
